import { BigScreenManagement } from '@gcpaas/data-room-ui';
export default {
  components: {
    BigScreenManagement: BigScreenManagement
  }
};